/* eslint-disable no-param-reassign */
import {
  PRIMER_NAME,
  OLIGO_SEQUENCE,
  MODIFICATION_3,
  MODIFICATION_5,
} from 'src/constants/forms';

export default class PlateWell {
  static NAME = 'plate_well';

  static getDetailsConfig(data) {
    const { plateName, row, column } = data;

    return {
      url: `/v2/oligos/plates/${plateName}/wells?row=${row}&column=${column}`
    };
  }

  static getPutConfig(data) {
    const { plateName, row, column } = data;

    const url = `/v2/oligos/plates/${plateName}/wells?row=${row}&column=${column}`;

    delete data.plateName;
    delete data.row;
    delete data.column;

    return { url };
  }

  static isDataValid(data = {}) {
    return !!(data[PRIMER_NAME]?.value && data[PRIMER_NAME]?.isValid &&
    data[OLIGO_SEQUENCE]?.value && data[OLIGO_SEQUENCE].isValid &&
    data[MODIFICATION_5]?.isValid &&
    data[MODIFICATION_3]?.isValid);
  }

  static processApiData(data = {}) {
    const modification3 = data[MODIFICATION_3]?.value;
    const modification5 = data[MODIFICATION_5]?.value;

    let processedData = {
      oligoName: data[PRIMER_NAME]?.value,
      oligoSequence: data[OLIGO_SEQUENCE]?.value,
    };

    if (modification3) {
      processedData = { ...processedData, modification3 };
    }

    if (modification5) {
      processedData = { ...processedData, modification5 };
    }

    return processedData;
  }

  constructor(plateWell = {}) {
    this.name = plateWell.name;
    this.errors = plateWell.errors || [];
    this[PRIMER_NAME] = plateWell.oligoName;
    this[OLIGO_SEQUENCE] = plateWell.oligoSequence;
    this[MODIFICATION_3] = plateWell.modification3;
    this[MODIFICATION_5] = plateWell.modification5;
  }
}
